<template>
  <div class="alert-data">
    <div v-if="actualAlertData || triggerTitle" class="row py-2">
      <div v-if="actualAlertData" class="col-md-6">
        <span class="alert-data__label">{{ actualAlertData.title }}</span>
        <p class="alert-data__value mb-0">
          {{ actualAlertData.value }}
        </p>
      </div>
      <div v-if="triggerTitle" class="col-md-6">
        <span class="alert-data__label">{{ triggerTitle }}</span>
        <p class="alert-data__value mb-0">
          {{ handleShowValue(alert.alertCode, alert.alertTrigger, 'trigger') }}
        </p>
      </div>
      <div v-if="!triggerTitle" class="col-md-6">
        <span class="alert-data__label">{{ $t('report.report.geofence') }}</span>
        <div class="alert-data__value alert-data__geofence-value">
          <div v-if="geofences.length" class="alert-data__geofence-list">
            <span
              v-for="(geofence, index) in visibleGeofences"
              :key="index"
              v-b-tooltip.hover.top
              :title="geofence"
              class="alert-data__geofence-name"
            >
              {{ truncateGeofenceName(geofence) }}
            </span>
            <span
              v-if="hiddenGeofenceCount"
              v-b-tooltip.hover.top
              :title="hiddenGeofencesTooltip"
              class="alert-data__geofence-more"
            >
              +{{ hiddenGeofenceCount }}
            </span>
          </div>
          <span v-else>-</span>
        </div>
      </div>
    </div>

    <div v-if="showOverspeedDuration" class="row py-2">
      <div class="col-md-6">
        <span class="alert-data__label">{{ $t('report.fields.duration') }}</span>
        <p class="alert-data__value">
          {{ overspeedDuration }}
        </p>
      </div>
      <div class="col-md-6">
        <span class="alert-data__label">
          {{ $t('setting.list.notification.form.durationThreshold') }}
        </span>
        <p class="alert-data__value">
          {{ overspeedThreshold }}
        </p>
      </div>
    </div>

    <div v-if="triggerTitle || !actualAlertData" class="row py-2">
      <div class="col-md-12">
        <span class="alert-data__label">{{ $t('report.report.geofence') }}</span>
        <div class="alert-data__value alert-data__geofence-value">
          <div v-if="geofences.length" class="alert-data__geofence-list">
            <span
              v-for="(geofence, index) in visibleGeofences"
              :key="index"
              v-b-tooltip.hover.top
              :title="geofence"
              class="alert-data__geofence-name"
            >
              {{ truncateGeofenceName(geofence) }}
            </span>
            <span
              v-if="hiddenGeofenceCount"
              v-b-tooltip.hover.top
              :title="hiddenGeofencesTooltip"
              class="alert-data__geofence-more"
            >
              +{{ hiddenGeofenceCount }}
            </span>
          </div>
          <span v-else>-</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Helper } from '@/mixin/helper'
import Notification from '@/mixin/notification'

export default {
  name: 'AlertData',
  mixins: [Helper, Notification],
  props: {
    alert: {
      type: Object,
      required: true,
    },
    maxVisibleGeofence: {
      type: Number,
      default: 2,
      validator: (value) => Number.isInteger(value) && value > 0,
    },
  },
  computed: {
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
    }),
    actualAlertData() {
      return this.getAlertData(this.alert)
    },
    triggerTitle() {
      return this.alertTriggerTitle(this.alert.alertCode)
    },
    alertDataParts() {
      return String(this.alert.alertData ?? '').split('|')
    },
    geofences() {
      return this.alert.geofences?.map((geofence) => geofence.fenceName) ?? []
    },
    visibleGeofences() {
      return this.geofences.slice(0, this.maxVisibleGeofence)
    },
    hiddenGeofences() {
      return this.geofences.slice(this.maxVisibleGeofence)
    },
    hiddenGeofenceCount() {
      return this.hiddenGeofences.length
    },
    hiddenGeofencesTooltip() {
      return this.hiddenGeofences.join(', ')
    },
    showOverspeedDuration() {
      return (
        this.hasAccess(['e4d-alert-overspeed-threshold-duration:read']) &&
        this.alert.alertCode === 8
      )
    },
    overspeedDuration() {
      return this.alertDataParts[1]
        ? `${this.alertDataParts[1]} ${this.$t('global.time.seconds')}`
        : '-'
    },
    overspeedThreshold() {
      return `${this.alertDataParts[3]?.trim() || 60} ${this.$t('global.time.seconds')}`
    },
  },
  methods: {
    truncateGeofenceName(name) {
      return name.length > 7 ? `${name.slice(0, 7)}...` : name
    },
  },
}
</script>

<style scoped lang="scss">
.alert-data__geofence-list {
  line-height: 25px;
  overflow-wrap: anywhere;
}

.alert-data__geofence-name + .alert-data__geofence-name::before {
  content: ', ';
}

.alert-data__geofence-more {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 25px;
  height: 25px;
  margin-left: 4px;
  padding: 0 8px;
  background: $green;
  color: $white;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  vertical-align: middle;
  white-space: nowrap;
}
</style>
